<div *ngIf="spinnerIsShown"
    style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<div class="modal-header bg-soft-info p-3">
    <h5 class="card-title" style="margin-bottom: 0;" i18n="@@">Load To Knowledge Base: {{model.fileName}}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()">
    </button>
</div>

<div class="card mb-0">
    <div class="card-body d-md-flex justify-content-between">
        <div class="row g-4 col-12 ">
            <div class="col-12 d-md-flex gap-2">
                <div class="col-12 col-md-8 ">
                    <label for="job-title-Input" class="form-label">Knowledge Base Tags</label>
                    <div class="form-control p-0" (click)="accessTypeListController()">
                        <div class="d-flex align-items-center form-control " style="padding: 0%; border-width: 0px;">
                            <ng-select style="flex-grow: 1; max-width: 100%;" [multiple]="true" bindLabel="name" [selectOnTab]="false" placeholder="Add Tags"
                                [clearSearchOnAdd]="true" [items]="permittedTagList" (focusout)="onBlurEvent($event)"
                                [isOpen]="isPermittedTagListOpen" [(ngModel)]="model.tags" [addTag]="addCustomTag"
                                [typeahead]="searchTerm$">

                                <ng-template ng-optgroup-tmp let-item="item">
                                    {{item}}
                                </ng-template>
                                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                    <div class="d-md-flex">
                                        <span class="ng-value-icon left" (click)="clear(item)">×</span>
                                        <span class="ng-value-label text-white">
                                            {{item}}
                                        </span>
                                    </div>
                                </ng-template>
                                <ng-template ng-tag-tmp let-item="item" let-clear="clear">
                                    <span class="ng-value-label ">
                                        <span style="font-size: 80% !important; ">
                                            Add Custom Tag:
                                        </span>
                                        <span>
                                            "{{searchTerm}}"
                                        </span>

                                    </span>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="justify-content-end" style="display: flex;">
        <div class="m-4 justify-content-end d-flex">
            <button class="btn btn-success w-100" type="submit" i18n="@@" (click)="onUpdate()">Load</button>
        </div>
    </div>
</div>